import Vue from '../../../plugins/vueFactory';

export default {
  setAttachments(state, payload) {
    state.checkoutAttachments = payload;
  },
  setCheckoutData(state, payload) {
    state.shoppingCart.checkoutType = payload.checkout_type;
    state.shoppingCart.shippingMethod = payload.shipping_method;
    state.shoppingCart.spSelectionRequired = payload.sp_selection_required;
    state.shoppingCart.transportMethodSelectionRequired =
      payload.transport_method_selection_required;

    if (payload.additional_info) {
      state.shoppingCart.additionalInfo = {
        reference: payload.additional_info.reference,
        inquiryOrOrderNumber: payload.additional_info.inquiry_or_order_number,
        comment: payload.additional_info.comment,
        attachments: payload.additional_info.attachments
      };
    }

    if (payload.billing_address) {
      state.shoppingCart.billingAddress = {
        companyName: payload.billing_address.company_name,
        addressLine1: payload.billing_address.address_line_1,
        addressLine2: payload.billing_address.address_line_2,
        zipCode: payload.billing_address.zip_code,
        city: payload.billing_address.city,
        countryCode: payload.billing_address.country_code,
        state: payload.billing_address.state
      };
    }

    if (payload.promo_codes) {
      Vue.set(
        state.shoppingCart,
        'promoCodes',
        payload.promo_codes.map(x => ({
          code: x.code,
          description: x.description
        }))
      );
    }

    if (payload.shipping_address) {
      state.shoppingCart.shippingAddress = {
        id: payload.shipping_address.address_id,
        companyName: payload.shipping_address.company_name,
        addressLine1: payload.shipping_address.address_line_1,
        addressLine2: payload.shipping_address.address_line_2,
        zipCode: payload.shipping_address.zip_code,
        city: payload.shipping_address.city,
        countryCode: payload.shipping_address.country_code,
        state: payload.shipping_address.state,
        isCustomerAddress: payload.shipping_address.is_customer_address
      };
    }

    if (payload.payment_method) {
      state.shoppingCart.paymentMethod = {
        id: payload.payment_method.id
      };
    }

    if (payload.sp) {
      state.shoppingCart.sp = {
        companyName: payload.sp.company_name,
        companyNumber: payload.sp.company_number,
        logo: payload.sp.logo,
        url: payload.sp.url
      };
    }

    if (payload.transport_method) {
      state.shoppingCart.transportMethod = {
        id: payload.transport_method.id,
        description: payload.transport_method.description,
        terms: payload.transport_method.terms,
        price: payload.transport_method.price
      };
    }

    if (payload.vouchers) {
      Vue.set(
        state.shoppingCart,
        'vouchers',
        payload.vouchers.map(x => ({
          code: x.code,
          value: x.value
        }))
      );
    }
  },
  setCountriesWithStates(state, payload) {
    state.countriesWithStates = payload;
  },
  setPaymentMethods(state, payload) {
    Vue.set(
      state,
      'paymentMethods',
      payload.payment_methods.map(x => ({
        id: x.id,
        description: x.description,
        terms: x.terms
      }))
    );
  },
  setServicePartners(state, payload) {
    Vue.set(
      state,
      'servicePartners',
      payload.service_partners.map(x => ({
        companyName: x.company_name,
        companyNumber: x.company_number,
        logo: x.logo,
        url: x.url
      }))
    );
  },
  setShippingAddresses(state, payload) {
    function mapAddresses(addresses) {
      return addresses.map(x => ({
        id: x.address_id,
        companyName: x.company_name,
        addressLine1: x.address_line_1,
        addressLine2: x.address_line_2,
        zipCode: x.zip_code,
        city: x.city,
        countryCode: x.country_code,
        state: x.state
      }));
    }

    Vue.set(
      state.shippingAddresses,
      'companyAddresses',
      mapAddresses(payload.company_addresses)
    );

    Vue.set(
      state.shippingAddresses,
      'customerAddresses',
      mapAddresses(payload.customer_addresses)
    );
  },
  setTransportMethods(state, payload) {
    Vue.set(
      state,
      'transportMethods',
      payload.transport_methods?.map(x => ({
        id: x.id,
        description: x.description,
        terms: x.terms,
        price: x.price
      }))
    );
  },
  setPaymentSuccessURL(state, url) {
    Vue.set(state, 'paymentSuccessURL', url);
  }
};
